// extracted by mini-css-extract-plugin
module.exports = {"n-spacer--line":"Spacer_n-spacer--line__DqO_E"};